<template>
    <div id="homepage">

        <!-- About -->
        <section class="content-section bg-light">
          <div class="container text-center">
            <div class="row">
              <!--<div id="coin_container" class="col-lg-4 mx-auto mb-5">
                  <div class="coin">
                    <div class="front"></div>
                    <div class="front_b"></div>
                    <div class="back"></div>
                    <div class="back_b"></div>
                  </div>
              </div>
              -->

              <!-- The Coin -->
              <div class="col-lg-4 mx-auto mb-5 pb-5">
                <div class="purse " >
                <div class="coin">
                  <div class="front">
                    <img src="../assets/fiorinov2.png" style="height:100%" alt="">
                  </div>
                  <div class="back"> 
                    <img src="../assets/backv2.png" style="height:100%" alt="">
                  </div>
                  <div class="side">
                    <div class="spoke"></div>
                    <div class="spoke"></div>
                    <div class="spoke"></div>
                    <div class="spoke"></div>
                    <div class="spoke"></div>
                    <div class="spoke"></div>
                    <div class="spoke"></div>
                    <div class="spoke"></div>
                    <div class="spoke"></div>
                    <div class="spoke"></div>
                    <div class="spoke"></div>
                    <div class="spoke"></div>
                    <div class="spoke"></div>
                    <div class="spoke"></div>
                    <div class="spoke"></div>
                    <div class="spoke"></div>
                  </div>
                </div>
              </div>
              </div>
              

              <div class="col-lg-6">
                
                <p class="lead mb-5">{{$t("f_intro_des")}}
                  <br><b>{{$t("f_intro_des_fiorino")}}</b><br>{{$t("f_intro_des2")}}<br>

                </p>
                <p class="text-muted"><i> {{$t("f_intro_des3")}}</i></p>
              </div>
            </div>
          </div>
        </section>




      <section id="services" class="content-section-small text-white" style="background-color: #f0932b;">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 text-center">
            <h2 class="section-heading text-uppercase">{{$t("f_steps_title")}}</h2>
            <br><br>
            <H4></H4>
          </div>
        </div>
        <div class="row text-center">
          <div class="col-md-4">
            <span class="fa-stack fa-4x">
              <i class="fa fa-circle fa-stack-2x text-primary"></i>
              <i class="fas fa-wallet fa-stack-1x fa-inverse"></i>
            </span>
            <h4 class="service-heading">{{$t("f_wallet_title")}}</h4>

            <p class="">
              {{$t("f_wallet_des")}}
            </p>
          </div>
          <div class="col-md-4">
            <span class="fa-stack fa-4x">
              <i class="fa fa-circle fa-stack-2x text-primary"></i>
              <i class="fa fa-shopping-cart fa-stack-1x fa-inverse"></i>
            </span>
            <h4 class="service-heading">{{$t("f_portal_title")}}</h4>
            <p class="">{{$t("f_portal_des")}}
            </p>
          </div>
          <div class="col-md-4">
            <span class="fa-stack fa-4x">
              <i class="fa fa-circle fa-stack-2x text-primary"></i>
              <i class="fa fa-chart-pie fa-stack-1x fa-inverse"></i>
            </span>
            <h4 class="service-heading">{{$t("f_strat_title")}}</h4>
            <p class="">{{$t("f_strat_des")}}
            </p>
          </div>
        </div>
      </div>
    </section>




    <!-- About -->
    <section id="about">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 text-center">
            <h2 class="section-heading text-uppercase">{{$t("f_sys_title")}}</h2>
            <h3 class="section-subheading text-muted">{{$t("f_sys_subtitle")}}</h3>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <ul class="timeline">
              <li>
                <div class="timeline-image">
                  <img class="rounded-circle img-fluid" src="../assets/fiorinov2.png" alt="">
                </div>
                <div class="timeline-panel">
                  <div class="timeline-heading">
                    <h4>{{$t("f_sys_f_title")}}</h4>
                    <h5 class="subheading text-muted">{{$t("f_sys_f_value")}}</h5>
                  </div>
                  <div class="timeline-body">
                    <p class="text-muted">{{$t("f_sys_f_des")}}
                      </p>
                  </div>
                </div>
              </li>
              <li class="timeline-inverted">
                <div class="timeline-image">
                  <img class="rounded-circle img-fluid" src="../assets/soldov2.png" alt="">
                </div>
                <div class="timeline-panel">
                  <div class="timeline-heading">
                    <h4>{{$t("f_sys_s_title")}}</h4>
                    <h5 class="subheading text-muted">{{$t("f_sys_s_value")}}</h5>
                  </div>
                  <div class="timeline-body">
                    <p class="text-muted">{{$t("f_sys_s_des")}}<br>
                    <b>{{$t("f_sys_s_des2")}}</b><br>
                    {{$t("f_sys_s_des3")}}
                    </p>
                  </div>
                </div>
              </li>
              <li>
                <div class="timeline-image">
                  <img class="rounded-circle img-fluid" src="../assets/quattrinov2.png" alt="">
                </div>
                <div class="timeline-panel">
                  <div class="timeline-heading">
                    <h4>{{$t("f_sys_q_title")}}</h4>
                    <h5 class="subheading text-muted">{{$t("f_sys_q_value")}}</h5>
                  </div>
                  <div class="timeline-body">
                    <p class="text-muted">{{$t("f_sys_q_des")}}<br>
                    <b>{{$t("f_sys_q_des2")}}</b><br>
                    {{$t("f_sys_q_des3")}}
                    </p>
                  </div>
                </div>
              </li>
              <li class="timeline-inverted">
                <div class="timeline-image">
                  <img class="rounded-circle img-fluid" src="../assets/denarov2.png" alt="">
                </div>
                <div class="timeline-panel">
                  <div class="timeline-heading">
                    <h4>{{$t("f_sys_d_title")}}</h4>
                    <h5 class="subheading text-muted">{{$t("f_sys_d_value")}}</h5>
                  </div>
                  <div class="timeline-body">
                    <p class="text-muted">{{$t("f_sys_d_des")}}<br>
                    <b>{{$t("f_sys_d_des2")}}</b><br>
                     {{$t("f_sys_d_des3")}}</p>
                  </div>
                </div>
              </li>
              <li class="timeline-inverted">
                <div class="timeline-image">
                  <h4>{{$t("f_sys_outro")}}
                    <br>{{$t("f_sys_outro2")}}
                    <br>{{$t("f_sys_outro3")}}</h4>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>


    

    </div>

</template>

<script>




export default {
  name: "CurrencyDetail",
  data() {
    return {};
  }
};
</script>

<style scoped>


.purse {
  height: 160px;
  width: 160px;
  position: relative;
  top: 50%;
  left: 50%;
  margin-top: -80px;
  margin-left: -80px;
  -webkit-perspective: 1000;
  -webkit-box-reflect: below 0 linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0) 45%, rgba(255, 255, 255, 0.2));
  -webkit-filter: saturate(1.45) hue-rotate(2deg);
}
.coin {
  height: 160px;
  width: 160px;
  position: relative;
  -webkit-transform-style: preserve-3d;
  -webkit-transform-origin: 50%;
  -webkit-animation: spin 2s infinite;
  -webkit-animation-timing-function: linear;
}
.coin .front,
.coin .back {
  position: absolute;
  height: 160px;
  width: 160px;
  border-radius: 50%;
  background-size: cover;
}
.coin .front {
  -webkit-transform: translateZ(8px);
}
.coin .back {
  -webkit-transform: translateZ(-8px) rotateY(180deg);
}
.coin .side {
  -webkit-transform: translateX(72px);
  -webkit-transform-style: preserve-3d;
  -webkit-backface-visibility: hidden;
}
.coin .side .spoke {
  height: 160px;
  width: 16px;
  position: absolute;
  -webkit-transform-style: preserve-3d;
  -webkit-backface-visibility: hidden;
}
.coin .side .spoke:before,
.coin .side .spoke:after {
  content: '';
  display: block;
  height: 15.68274245px;
  width: 16px;
  position: absolute;
  -webkit-transform: rotateX(84.375deg);
  background: #d8be83;
  background: linear-gradient(to bottom, #e6cf99 0%, #e6cf99 74%, #c2a970 75%, #c2a970 100%);
  background-size: 100% 3.48505388px;
}
.coin .side .spoke:before {
  -webkit-transform-origin: top center;
}
.coin .side .spoke:after {
  bottom: 0;
  -webkit-transform-origin: center bottom;
}
.coin .side .spoke:nth-child(16) {
  -webkit-transform: rotateY(90deg) rotateX(180deg);
}
.coin .side .spoke:nth-child(15) {
  -webkit-transform: rotateY(90deg) rotateX(168.75deg);
}
.coin .side .spoke:nth-child(14) {
  -webkit-transform: rotateY(90deg) rotateX(157.5deg);
}
.coin .side .spoke:nth-child(13) {
  -webkit-transform: rotateY(90deg) rotateX(146.25deg);
}
.coin .side .spoke:nth-child(12) {
  -webkit-transform: rotateY(90deg) rotateX(135deg);
}
.coin .side .spoke:nth-child(11) {
  -webkit-transform: rotateY(90deg) rotateX(123.75deg);
}
.coin .side .spoke:nth-child(10) {
  -webkit-transform: rotateY(90deg) rotateX(112.5deg);
}
.coin .side .spoke:nth-child(9) {
  -webkit-transform: rotateY(90deg) rotateX(101.25deg);
}
.coin .side .spoke:nth-child(8) {
  -webkit-transform: rotateY(90deg) rotateX(90deg);
}
.coin .side .spoke:nth-child(7) {
  -webkit-transform: rotateY(90deg) rotateX(78.75deg);
}
.coin .side .spoke:nth-child(6) {
  -webkit-transform: rotateY(90deg) rotateX(67.5deg);
}
.coin .side .spoke:nth-child(5) {
  -webkit-transform: rotateY(90deg) rotateX(56.25deg);
}
.coin .side .spoke:nth-child(4) {
  -webkit-transform: rotateY(90deg) rotateX(45deg);
}
.coin .side .spoke:nth-child(3) {
  -webkit-transform: rotateY(90deg) rotateX(33.75deg);
}
.coin .side .spoke:nth-child(2) {
  -webkit-transform: rotateY(90deg) rotateX(22.5deg);
}
.coin .side .spoke:nth-child(1) {
  -webkit-transform: rotateY(90deg) rotateX(11.25deg);
}
.coin.skeleton .front,
.coin.skeleton .back {
  display: none;
}
.coin.skeleton .side,
.coin.skeleton .side .spoke,
.coin.skeleton .side .spoke:before,
.coin.skeleton .side .spoke:after {
  -webkit-backface-visibility: visible;
}
.coin.skeleton .side .spoke {
  background: rgba(170, 170, 170, 0.1);
}
.coin.skeleton .side .spoke:before {
  background: rgba(255, 170, 170, 0.2);
}
.coin.skeleton .side .spoke:after {
  background: rgba(204, 204, 255, 0.2);
}
body {
  background-color: #000;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
@-webkit-keyframes spin {
  from {
    -webkit-transform: rotateY(0deg);
  }
  to {
    -webkit-transform: rotateY(360deg);
  }
}
@keyframes spin {
  from {
    transform: rotateY(0deg);
  }
  to {
    transform: rotateY(360deg);
  }
}



/* DONE */



.textall{
    color: #303030;
}

.texto {
    color: #f0932b;
}

.titler {
    color: #f0932b;
    font-weight: bold;
}

.buttora {
    color: rgb(71, 71, 71);
    background-color: #f0932b;
}


















p {
  line-height: 1.75;
}

a {
  color: #fed136;
}

a:hover {
  color: #fec503;
}

.text-primary {
  color: #fed136 !important;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: 700;
  font-family: 'Montserrat', 'Helvetica Neue', Helvetica, Arial, sans-serif;
}

section {
  padding: 100px 0;
}

section h2.section-heading {
  font-size: 40px;
  margin-top: 0;
  margin-bottom: 15px;
}

section h3.section-subheading {
  font-size: 16px;
  font-weight: 400;
  font-style: italic;
  margin-bottom: 75px;
  text-transform: none;
  font-family: 'Droid Serif', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  color: #1D809F
}

@media (min-width: 768px) {
  section {
    padding: 150px 0;
  }
}

.btn {
  font-family: 'Montserrat', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-weight: 700;
}

.btn-xl {
  font-size: 18px;
  padding: 20px 40px;
}

.btn-primary {
  background-color: #fed136;
  border-color: #fed136;
}

.btn-primary:active, .btn-primary:focus, .btn-primary:hover {
  background-color: #fec810 !important;
  border-color: #fec810 !important;
  color: white;
}

.btn-primary:active, .btn-primary:focus {
  box-shadow: 0 0 0 0.2rem rgba(254, 209, 55, 0.5) !important;
}

::-moz-selection {
  background: #fed136;
  text-shadow: none;
}

::selection {
  background: #fed136;
  text-shadow: none;
}

img::selection {
  background: transparent;
}

img::-moz-selection {
  background: transparent;
}

#mainNav {
  background-color: #212529;
}

#mainNav .navbar-toggler {
  font-size: 12px;
  right: 0;
  padding: 13px;
  text-transform: uppercase;
  color: white;
  border: 0;
  background-color: #fed136;
  font-family: 'Montserrat', 'Helvetica Neue', Helvetica, Arial, sans-serif;
}

#mainNav .navbar-brand {
  color: #fed136;
  font-family: 'Kaushan Script', 'Helvetica Neue', Helvetica, Arial, cursive;
}

#mainNav .navbar-brand.active, #mainNav .navbar-brand:active, #mainNav .navbar-brand:focus, #mainNav .navbar-brand:hover {
  color: #fec503;
}

#mainNav .navbar-nav .nav-item .nav-link {
  font-size: 90%;
  font-weight: 400;
  padding: 0.75em 0;
  letter-spacing: 1px;
  color: white;
  font-family: 'Montserrat', 'Helvetica Neue', Helvetica, Arial, sans-serif;
}

#mainNav .navbar-nav .nav-item .nav-link.active, #mainNav .navbar-nav .nav-item .nav-link:hover {
  color: #fed136;
}

@media (min-width: 992px) {
  #mainNav {
    padding-top: 25px;
    padding-bottom: 25px;
    -webkit-transition: padding-top 0.3s, padding-bottom 0.3s;
    -moz-transition: padding-top 0.3s, padding-bottom 0.3s;
    transition: padding-top 0.3s, padding-bottom 0.3s;
    border: none;
    background-color: transparent;
  }
  #mainNav .navbar-brand {
    font-size: 1.75em;
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    transition: all 0.3s;
  }
  #mainNav .navbar-nav .nav-item .nav-link {
    padding: 1.1em 1em !important;
  }
  #mainNav.navbar-shrink {
    padding-top: 0;
    padding-bottom: 0;
    background-color: #212529;
  }
  #mainNav.navbar-shrink .navbar-brand {
    font-size: 1.25em;
    padding: 12px 0;
  }
}

header.masthead {
  text-align: center;
  color: white;
  background-repeat: no-repeat;
  background-attachment: scroll;
  background-position: center center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}

header.masthead .intro-text {
  padding-top: 150px;
  padding-bottom: 100px;
}

header.masthead .intro-text .intro-lead-in {
  font-size: 22px;
  font-style: italic;
  line-height: 22px;
  margin-bottom: 25px;
  font-family: 'Droid Serif', 'Helvetica Neue', Helvetica, Arial, sans-serif;
}

header.masthead .intro-text .intro-heading {
  font-size: 50px;
  font-weight: 700;
  line-height: 50px;
  margin-bottom: 25px;
  font-family: 'Montserrat', 'Helvetica Neue', Helvetica, Arial, sans-serif;
}

@media (min-width: 768px) {
  header.masthead .intro-text {
    padding-top: 300px;
    padding-bottom: 200px;
  }
  header.masthead .intro-text .intro-lead-in {
    font-size: 40px;
    font-style: italic;
    line-height: 40px;
    margin-bottom: 25px;
    font-family: 'Droid Serif', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  }
  header.masthead .intro-text .intro-heading {
    font-size: 75px;
    font-weight: 700;
    line-height: 75px;
    margin-bottom: 50px;
    font-family: 'Montserrat', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  }
}

.service-heading {
  margin: 15px 0;
  text-transform: none;
}

#portfolio .portfolio-item {
  right: 0;
  margin: 0 0 15px;
}

#portfolio .portfolio-item .portfolio-link {
  position: relative;
  display: block;
  max-width: 400px;
  margin: 0 auto;
  cursor: pointer;
}

#portfolio .portfolio-item .portfolio-link .portfolio-hover {
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-transition: all ease 0.5s;
  -moz-transition: all ease 0.5s;
  transition: all ease 0.5s;
  opacity: 0;
  background: rgba(254, 209, 54, 0.9);
}

#portfolio .portfolio-item .portfolio-link .portfolio-hover:hover {
  opacity: 1;
}

#portfolio .portfolio-item .portfolio-link .portfolio-hover .portfolio-hover-content {
  font-size: 20px;
  position: absolute;
  top: 50%;
  width: 100%;
  height: 20px;
  margin-top: -12px;
  text-align: center;
  color: white;
}

#portfolio .portfolio-item .portfolio-link .portfolio-hover .portfolio-hover-content i {
  margin-top: -12px;
}

#portfolio .portfolio-item .portfolio-link .portfolio-hover .portfolio-hover-content h3,
#portfolio .portfolio-item .portfolio-link .portfolio-hover .portfolio-hover-content h4 {
  margin: 0;
}

#portfolio .portfolio-item .portfolio-caption {
  max-width: 400px;
  margin: 0 auto;
  padding: 25px;
  text-align: center;
  background-color: #fff;
}

#portfolio .portfolio-item .portfolio-caption h4 {
  margin: 0;
  text-transform: none;
}

#portfolio .portfolio-item .portfolio-caption p {
  font-size: 16px;
  font-style: italic;
  margin: 0;
  font-family: 'Droid Serif', 'Helvetica Neue', Helvetica, Arial, sans-serif;
}

#portfolio * {
  z-index: 2;
}

@media (min-width: 767px) {
  #portfolio .portfolio-item {
    margin: 0 0 30px;
  }
}

.portfolio-modal {
  padding-right: 0px !important;
}

.portfolio-modal .modal-dialog {
  margin: 1rem;
  max-width: 100vw;
}

.portfolio-modal .modal-content {
  padding: 100px 0;
  text-align: center;
}

.portfolio-modal .modal-content h2 {
  font-size: 3em;
  margin-bottom: 15px;
}

.portfolio-modal .modal-content p {
  margin-bottom: 30px;
}

.portfolio-modal .modal-content p.item-intro {
  font-size: 16px;
  font-style: italic;
  margin: 20px 0 30px;
  font-family: 'Droid Serif', 'Helvetica Neue', Helvetica, Arial, sans-serif;
}

.portfolio-modal .modal-content ul.list-inline {
  margin-top: 0;
  margin-bottom: 30px;
}

.portfolio-modal .modal-content img {
  margin-bottom: 30px;
}

.portfolio-modal .modal-content button {
  cursor: pointer;
}

.portfolio-modal .close-modal {
  position: absolute;
  top: 25px;
  right: 25px;
  width: 75px;
  height: 75px;
  cursor: pointer;
  background-color: transparent;
}

.portfolio-modal .close-modal:hover {
  opacity: 0.3;
}

.portfolio-modal .close-modal .lr {
  /* Safari and Chrome */
  z-index: 1051;
  width: 1px;
  height: 75px;
  margin-left: 35px;
  /* IE 9 */
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
  background-color: #212529;
}

.portfolio-modal .close-modal .lr .rl {
  /* Safari and Chrome */
  z-index: 1052;
  width: 1px;
  height: 75px;
  /* IE 9 */
  -webkit-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  transform: rotate(90deg);
  background-color: #212529;
}

.timeline {
  position: relative;
  padding: 0;
  list-style: none;
}

.timeline:before {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 40px;
  width: 2px;
  margin-left: -1.5px;
  content: '';
  background-color: #e9ecef;
}

.timeline > li {
  position: relative;
  min-height: 50px;
  margin-bottom: 50px;
}

.timeline > li:after, .timeline > li:before {
  display: table;
  content: ' ';
}

.timeline > li:after {
  clear: both;
}

.timeline > li .timeline-panel {
  position: relative;
  float: right;
  width: 100%;
  padding: 0 20px 0 100px;
  text-align: left;
}

.timeline > li .timeline-panel:before {
  right: auto;
  left: -15px;
  border-right-width: 15px;
  border-left-width: 0;
}

.timeline > li .timeline-panel:after {
  right: auto;
  left: -14px;
  border-right-width: 14px;
  border-left-width: 0;
}

.timeline > li .timeline-image {
  position: absolute;
  z-index: 100;
  left: 0;
  width: 80px;
  height: 80px;
  margin-left: 0;
  text-align: center;
  color: white;
  border: 7px solid #e9ecef;
  border-radius: 100%;
  background-color: #fed136;
}

.timeline > li .timeline-image h4 {
  font-size: 10px;
  line-height: 14px;
  margin-top: 12px;
}

.timeline > li.timeline-inverted > .timeline-panel {
  float: right;
  padding: 0 20px 0 100px;
  text-align: left;
}

.timeline > li.timeline-inverted > .timeline-panel:before {
  right: auto;
  left: -15px;
  border-right-width: 15px;
  border-left-width: 0;
}

.timeline > li.timeline-inverted > .timeline-panel:after {
  right: auto;
  left: -14px;
  border-right-width: 14px;
  border-left-width: 0;
}

.timeline > li:last-child {
  margin-bottom: 0;
}

.timeline .timeline-heading h4 {
  margin-top: 0;
  color: inherit;
}

.timeline .timeline-heading h4.subheading {
  text-transform: none;
}

.timeline .timeline-body > ul,
.timeline .timeline-body > p {
  margin-bottom: 0;
}

@media (min-width: 768px) {
  .timeline:before {
    left: 50%;
  }
  .timeline > li {
    min-height: 100px;
    margin-bottom: 100px;
  }
  .timeline > li .timeline-panel {
    float: left;
    width: 41%;
    padding: 0 20px 20px 30px;
    text-align: right;
  }
  .timeline > li .timeline-image {
    left: 50%;
    width: 100px;
    height: 100px;
    margin-left: -50px;
  }
  .timeline > li .timeline-image h4 {
    font-size: 13px;
    line-height: 18px;
    margin-top: 16px;
  }
  .timeline > li.timeline-inverted > .timeline-panel {
    float: right;
    padding: 0 30px 20px 20px;
    text-align: left;
  }
}

@media (min-width: 992px) {
  .timeline > li {
    min-height: 150px;
  }
  .timeline > li .timeline-panel {
    padding: 0 20px 20px;
  }
  .timeline > li .timeline-image {
    width: 150px;
    height: 150px;
    margin-left: -75px;
  }
  .timeline > li .timeline-image h4 {
    font-size: 18px;
    line-height: 26px;
    margin-top: 30px;
  }
  .timeline > li.timeline-inverted > .timeline-panel {
    padding: 0 20px 20px;
  }
}

@media (min-width: 1200px) {
  .timeline > li {
    min-height: 170px;
  }
  .timeline > li .timeline-panel {
    padding: 0 20px 20px 100px;
  }
  .timeline > li .timeline-image {
    width: 170px;
    height: 170px;
    margin-left: -85px;
  }
  .timeline > li .timeline-image h4 {
    margin-top: 40px;
  }
  .timeline > li.timeline-inverted > .timeline-panel {
    padding: 0 100px 20px 20px;
  }
}

.team-member {
  margin-bottom: 50px;
  text-align: center;
}

.team-member img {
  width: 225px;
  height: 225px;
  border: 7px solid #fff;
}

.team-member h4 {
  margin-top: 25px;
  margin-bottom: 0;
  text-transform: none;
}

.team-member p {
  margin-top: 0;
}

section#contact {
  background-color: #212529;
  background-repeat: no-repeat;
  background-position: center;
}

section#contact .section-heading {
  color: #fff;
}

section#contact .form-group {
  margin-bottom: 25px;
}

section#contact .form-group input,
section#contact .form-group textarea {
  padding: 20px;
}

section#contact .form-group input.form-control {
  height: auto;
}

section#contact .form-group textarea.form-control {
  height: 248px;
}

section#contact .form-control:focus {
  border-color: #fed136;
  box-shadow: none;
}

section#contact ::-webkit-input-placeholder {
  font-weight: 700;
  color: #ced4da;
  font-family: 'Montserrat', 'Helvetica Neue', Helvetica, Arial, sans-serif;
}

section#contact :-moz-placeholder {
  font-weight: 700;
  color: #ced4da;
  /* Firefox 18- */
  font-family: 'Montserrat', 'Helvetica Neue', Helvetica, Arial, sans-serif;
}

section#contact ::-moz-placeholder {
  font-weight: 700;
  color: #ced4da;
  /* Firefox 19+ */
  font-family: 'Montserrat', 'Helvetica Neue', Helvetica, Arial, sans-serif;
}

section#contact :-ms-input-placeholder {
  font-weight: 700;
  color: #ced4da;
  font-family: 'Montserrat', 'Helvetica Neue', Helvetica, Arial, sans-serif;
}

footer {
  padding: 25px 0;
  text-align: center;
}

footer span.copyright {
  font-size: 90%;
  line-height: 40px;
  text-transform: none;
  font-family: 'Montserrat', 'Helvetica Neue', Helvetica, Arial, sans-serif;
}

footer ul.quicklinks {
  font-size: 90%;
  line-height: 40px;
  margin-bottom: 0;
  text-transform: none;
  font-family: 'Montserrat', 'Helvetica Neue', Helvetica, Arial, sans-serif;
}

ul.social-buttons {
  margin-bottom: 0;
}

ul.social-buttons li a {
  font-size: 20px;
  line-height: 40px;
  display: block;
  width: 40px;
  height: 40px;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  transition: all 0.3s;
  color: white;
  border-radius: 100%;
  outline: none;
  background-color: #212529;
}

ul.social-buttons li a:active, ul.social-buttons li a:focus, ul.social-buttons li a:hover {
  background-color: #fed136;
}












.demo
{
	padding: 100px 0;
}
.heading-title
{
	margin-bottom: 100px;
}
.serviceBox{
    padding: 30px 30px 30px 90px;
    background: #f8f8f8;
    color: #333;
    overflow: hidden;
    position: relative;
    transition: all 0.3s ease-in-out 0s;
}

.serviceBox:hover{
    background: #645e9d;
    color: #fff;
}

.serviceBox:after{
    content: "";
    display: block;
    border-top: 500px solid #fff;
    border-left: 500px solid transparent;
    margin-top: -55%;
    margin-left: 100%;
    opacity: 0;
    position: absolute;
    transform: scale(2);
    transition: all 0.3s ease-in-out 0s;
}

.serviceBox:hover:after{
    margin-left: 0;
    opacity: 0.1;
}

.serviceBox .service-icon{
    font-size: 50px;
    color: #645e9d;
    position: absolute;
    top: 40px;
    left: 20px;
    transition:all 0.3s ease-in-out 0s;
}

.serviceBox:hover .service-icon{
    color: #fff;
}

.serviceBox .title{
    font-size: 22px;
    font-weight: 700;
    margin: 0 0 12px 0;
    text-transform: capitalize;
}

.serviceBox .description{
    font-size: 15px;
    color: #a3a3a3;
    line-height: 25px;
    margin: 0;
    transition: all 0.3s ease-in-out 0s;
}

.serviceBox:hover .description{
    color: #fff;
}

@media only screen and (max-width: 990px){
    .serviceBox{ margin-bottom: 15px; }
}
</style>



// WEBPACK FOOTER //
// src/components/Fiorino.vue